import type { SignableDocumentDetailActivity } from '@/modules/documents/types/documents.types'
import type { SchemaConfig } from '@/modules/shared/helpers/create-yup-schema'

export const fieldsToSchema = (fields: SignableDocumentDetailActivity['definition']['fields']) => {
  return (
    fields?.reduce((accumulator, current) => {
      const { id, type: inputType, required } = current
      // const isTextInput = type === 'text'
      // const isCheckbox = type === 'checkbox'
      const fieldSchema = {
        id,
        type: inputType === 'checkbox' ? 'boolean' : 'text',
        validationType: inputType === 'checkbox' ? 'boolean' : 'string',
        validations: [] as SchemaConfig['validations'],
      }
      if (required) {
        fieldSchema.validations = [
          {
            type: 'required',
            params: ['Dit is een verplicht veld'],
          },
        ]
      }
      accumulator.push(fieldSchema)
      return accumulator
    }, [] as SchemaConfig[]) || {}
  )
}
